import { render, staticRenderFns } from "./AnswerOptions.vue?vue&type=template&id=09bc16a6&"
import script from "./AnswerOptions.vue?vue&type=script&lang=js&"
export * from "./AnswerOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports